import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { countryToIso } from '@sola/schema/dotcom/shared/geo.ts';
import { type GraphQLCommitment } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { getAgeFromBirthday } from '@sola/shared-utils/children/utils.ts';
import { isCorrespondentCommitment } from '@sola/shared-utils/supporters/commitments.ts';
import { getElapsed } from '@sola/utils/relativeTime.ts';
export const useAffinityCardSponsorship = commitment => {
  const $ = _c(32);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["my", "geo"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation(t0);
  const {
    participant,
    dates,
    lastCorrespondenceDate
  } = commitment;
  let birthdate;
  let childName;
  let globalId;
  let isCorrespondent;
  let lastWrittenDays;
  let photoUrl;
  let startDate;
  let t1;
  if ($[1] !== commitment || $[2] !== dates?.start || $[3] !== lastCorrespondenceDate || $[4] !== participant || $[5] !== t) {
    const {
      globalId: t2,
      name,
      photoUrl: t3,
      birthdate: t4
    } = participant ?? {};
    globalId = t2;
    photoUrl = t3;
    birthdate = t4;
    childName = name;
    startDate = dates?.start;
    let t5;
    if ($[14] !== commitment) {
      t5 = isCorrespondentCommitment(commitment);
      $[14] = commitment;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    isCorrespondent = t5;
    let t6;
    if ($[16] !== lastCorrespondenceDate || $[17] !== t) {
      t6 = lastCorrespondenceDate ? getElapsed(lastCorrespondenceDate) : t("my:homepage.affinityCard.sponsorship.lastWritten_fallback");
      $[16] = lastCorrespondenceDate;
      $[17] = t;
      $[18] = t6;
    } else {
      t6 = $[18];
    }
    lastWrittenDays = t6;
    const rawAge = birthdate ? getAgeFromBirthday(birthdate) : "";
    const age = typeof rawAge === "number" ? rawAge : undefined;
    const t7 = participant?.country;
    const t8 = participant?.localId ?? undefined;
    let t9;
    if ($[19] !== t7 || $[20] !== t8) {
      t9 = countryToIso(t7, t8);
      $[19] = t7;
      $[20] = t8;
      $[21] = t9;
    } else {
      t9 = $[21];
    }
    const countryIso = t9;
    const translatedCountry = countryIso ? t(`geo:countries.${countryIso}.nameS`) : participant?.country;
    t1 = t("my:homepage.affinityCard.sponsorship.summary", {
      childName,
      count: age,
      country: translatedCountry
    });
    $[1] = commitment;
    $[2] = dates?.start;
    $[3] = lastCorrespondenceDate;
    $[4] = participant;
    $[5] = t;
    $[6] = birthdate;
    $[7] = childName;
    $[8] = globalId;
    $[9] = isCorrespondent;
    $[10] = lastWrittenDays;
    $[11] = photoUrl;
    $[12] = startDate;
    $[13] = t1;
  } else {
    birthdate = $[6];
    childName = $[7];
    globalId = $[8];
    isCorrespondent = $[9];
    lastWrittenDays = $[10];
    photoUrl = $[11];
    startDate = $[12];
    t1 = $[13];
  }
  const summary = t1;
  let t2;
  if ($[22] !== birthdate || $[23] !== childName || $[24] !== globalId || $[25] !== isCorrespondent || $[26] !== lastWrittenDays || $[27] !== photoUrl || $[28] !== startDate || $[29] !== summary || $[30] !== t) {
    t2 = {
      t,
      globalId,
      childName,
      photoUrl,
      birthdate,
      startDate,
      isCorrespondent,
      summary,
      lastWrittenDays
    };
    $[22] = birthdate;
    $[23] = childName;
    $[24] = globalId;
    $[25] = isCorrespondent;
    $[26] = lastWrittenDays;
    $[27] = photoUrl;
    $[28] = startDate;
    $[29] = summary;
    $[30] = t;
    $[31] = t2;
  } else {
    t2 = $[31];
  }
  return t2;
};